import { Injectable } from '@angular/core';
import { ParentService } from '../../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { constant} from '../../../app.constants';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';


@Injectable()
export class ReservationNoteService extends ParentService {
  private noteTemplateSubject = new Subject<{ openModal: boolean, rowData: any }>();
  noteTemplateSubject$ = this.noteTemplateSubject.asObservable();

    constructor(private http: Http, private route: Router) {
        super();
    }

    noteTermplateSendData(data: { openModal: boolean, rowData: any }) {
      this.noteTemplateSubject.next(data);
    }

    /**
     *
     * @returns {Observable<R>}
     */
    public getTripNotes(id) {
        return this.http.get(constant.URL_TRIP_NOTES + '/list/' + id, this.getHeader())
            .map(resp => resp.json());
    }

    public getTripNote(id) {
        return this.http.get(constant.URL_TRIP_NOTES + '/' + id, this.getHeader())
            .map(resp => resp.json());
    }

    public getSpeedNote(ptr) {
        return this.
        http.get(constant.URL_TRIP_NOTES + '/NoteCategoryValues?noteCategoryValueId=3&speedcode='
            + ptr , this.getHeader())
            .map(resp => resp.json());
    }

    public getUserAll() {
        return this.http.get(constant.URL_USER_PROFILE_ALL, this.getHeader())
            .map(resp => resp.json());
    }

    public deleteTripNote(data) {
        return this.http.delete(constant.URL_TRIP_NOTES + '/' + data, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }


    /**
     *
     * @param data
     * @returns {Observable<R>}
     */
    public postTripNote(data: any){
        const bodyString = JSON.stringify(data);
        return this.http.post(constant.URL_TRIP_NOTES, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * se modificó para crear nuevo servicio
     * @returns {Observable<R>}
     */
    public putTripNote(data) {
        const bodyString = JSON.stringify(data);
        return this.http.put(constant.URL_TRIP_NOTES, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }


    public getTypesNotes(id: number) {
      return this.http
        .get(
          constant.URL_GET_NOTECATEGORY + '?noteCategoryValueId=' + id,
          this.getHeader()
        )
        .map((resp) => resp.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

    public getStandingNotes(id) {
      return this.http.get(constant.URL_STANDING_NOTES+'/List/' + id, this.getHeader()).map(resp => resp.json());
    }

    public getStandingNote(id) {
      return this.http.get(constant.URL_STANDING_NOTES+'/' + id, this.getHeader()).map(resp => resp.json());
    }

    public deleteStandingNote(data) {
      return this.http.delete(constant.URL_STANDING_NOTES + '/' + data, this.headerPost()).map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

    public postStandingNote(data: any) {
      const bodyString = JSON.stringify(data);
      return this.http.post(constant.URL_STANDING_NOTES, bodyString, this.headerPost()).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
    }

    public putStandingOrderNote(data){
      const bodyString = JSON.stringify(data);
      return this.http.put(constant.URL_STANDING_NOTES, bodyString, this.headerPost())
      .map((res: Response) => res.json()).catch((error: any) => Observable.throw(error.json()));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-notes/reservation-note.service.ts